import { computed } from "vue";
import { usePersistentState } from "~/composables/usePersistentState";
import { useLanguage } from "~/composables/useLanguage";
import {Terminal, TerminalDetailResponse} from "~/types/terminal";
import { PUMP_TYPE } from "~/constants/pumpType";
import {ApiResponse} from "~/types/response";
import {useState} from "nuxt/app";
import {useFetchWithJwt} from "~/composables/useFetchWithJwt";
import {useHandleCode} from "~/composables/useHandleCode";

export function useTerminal() {
	const { fetchWithJwt } = useFetchWithJwt();
	const { handleCode, handleCodeDepth, handleSuccessCode, handleErrorCode } = useHandleCode();
	const { lang } = useLanguage();
	const terminals = usePersistentState<Terminal[]>('terminals', () => []);

	function useTerminalByType(type: string) {
		return computed(() => {
			return terminals.value
				.filter(t => t.pumpType === type)
				.sort((a, b) => a.id - b.id) ?? null;
		});
	}

	// fireTerminal 정보(id값이 가장 작은 값으로 정렬)
	const fireTerminals = useTerminalByType(PUMP_TYPE.FIRE);
	// fireTerminal 정보(id값이 가장 작은 값)
	const fireTerminal = computed(() => {
		return fireTerminals.value.length > 0 ? fireTerminals.value[0] : null;
	});
	// fireTerminal 정보(id값이 가장 작은 값으로 정렬)
	const waterTerminals = useTerminalByType(PUMP_TYPE.WATER);
	// waterTerminal 정보(id값이 가장 작은 값)
	const waterTerminal = computed(() => {
		return waterTerminals.value.length > 0 ? waterTerminals.value[0] : null;
	});
	// fireTerminal 정보(id값이 가장 작은 값으로 정렬)
	const drainageTerminals = useTerminalByType(PUMP_TYPE.DRAINAGE);
	// drainageTerminal 정보(id값이 가장 작은 값)
	const drainageTerminal = computed(() => {
		return drainageTerminals.value.length > 0 ? drainageTerminals.value[0] : null;
	});

	// 선택된 터미널 deviceId
	const selectedTerminalDeviceId = usePersistentState<number | null>('selectedTerminalDeviceId', () => null);
	// 선택된 터미널 정보
	const selectedTerminal = computed(() => {
		return terminals.value.find(t => t.deviceId === selectedTerminalDeviceId.value);
	});

	// 네트워크 상태 저장용
	const networkStatusValue = useState<number>('networkStatusValue', () => -1); // -1: 초기값, 0: 오프라인, 1: 온라인
	const networkStatusClass = useState<string>('networkStatusClass', () => '-'); // 네트워크 상태 class

	// 언어팩에서 불러올 코드 그룹(메인)
	const gammaCodes = 'gamma';
	// 언어팩에서 불러올 코드 그룹(서브)
	const gammaNetworkStatusCodes = 'gammaNetworkStatus';
	// 네트워크 상태 (언어팩 변경에 반응)
	const networkStatus = computed(() => {
		if (networkStatusValue.value === -1) return '-';
		return handleCode(gammaCodes, gammaNetworkStatusCodes, networkStatusValue.value) || String(networkStatusValue.value);
	});

	const fetchTerminalDetail = async (id: number): Promise<ApiResponse<TerminalDetailResponse>> => {
		return (await fetchWithJwt(`/terminal/detail/device/${id}`, {
			method: 'GET',
		})) as ApiResponse<TerminalDetailResponse>;
	};
	const handleTerminalDetail = async (id: number) => {
		console.log('[useTerminal.ts] handleTerminalDetail 함수 시작');
		try {
			const response = await fetchTerminalDetail(id);
			if (response && response.result === "success") {
				// 응답 데이터가 성공적으로 수신된 경우
				const data = response.data;

				const networtValue = data.isOffline ? 0 : 1;// 0:오프라인, 1:온라인
				networkStatusClass.value = data.isOffline ? 'color-red' : 'color-blue';
				networkStatusValue.value = networtValue; // 네트워크 상태 값 업데이트
			} else if (response && response.result === 'fail') {
				console.log('faile :',response);
			}
		} catch (error) {
			console.error('Error fetching gamma data:', error);
		}
		console.log('[useTerminal.ts] handleTerminalDetail 함수 종료');
	};


	return {
		terminals, fireTerminal, fireTerminals, waterTerminal, waterTerminals, drainageTerminal, drainageTerminals, selectedTerminalDeviceId, selectedTerminal,
		networkStatus, networkStatusClass, fetchTerminalDetail, handleTerminalDetail
	};
}